export default __webpack_public_path__ + "static/media/CFDI.883b94f0.png";